<template>
  <div class="slideshow">
    <transition name="fade">
      <div class="stage">
        <img src="/assets/venue-1.png" />
      </div>
    </transition>
    <transition name="fade">
      <div class="content">
        <img src="/assets/pathfinder.png" />
        <img src="/assets/pathfinder.png" class="reflected-image" />
        <em class="fadeout"></em>

        <transition name="fade">
          <div class="nav" v-show="show">
            <h1>Allgäuer Bergrettungstag 2020</h1>

            <ul>
              <li v-for="(talk, index) in $_talks()" :key="index">
                {{ talk.localDate }}
                <router-link :to="{ name: 'Talk', params: { id: talk.id } }">
                  {{ talk.title }}
                </router-link>
                <small>{{ talk.speakerNames.join(", ") }}</small>
              </li>

              <li class="mt-1">
                <router-link to="/sponsors">
                  Unsere Sponsoren
                  <small>
                    Nur durch die Unterstützung unserer Sponsoren ist diese
                    Veranstaltungsreihe möglich
                  </small>
                </router-link>
              </li>
            </ul>

            <div class="partners">
              <a href="https://www.gebirgsmedizin.de" target="_new">
                <img src="/assets/partner-1.png" />
              </a>
              <small>In Zusammenarbeit mit:</small>
              <a href="https://www.bergwacht-bayern.de" target="_new">
                <img src="/assets/partner-2.png" />
              </a>
              <a href="http://www.stiftung-bergwacht.org" target="_new">
                <img src="/assets/partner-3.png" />
              </a>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Talks",

  data() {
    return { show: true };
  },

  mounted() {
    // setTimeout(() => {
    //   this.show = true;
    // }, 200);
  },
};
</script>

<style scoped>
.nav {
  width: 60% !important;
  background: rgb(1, 1, 1, 0.6);
  padding-left: 1em !important;
}

.nav ul {
  color: #fff;
  padding: 0 2em;
}

.nav li {
  margin-top: 0.25em;
}

.nav a {
  font-weight: bold;
  text-decoration: none;
  color: #eee;
}
li small {
  display: block;
  font-size: 64%;
  font-weight: normal !important;
  text-decoration: none !important;
}

.nav a.router-link-exact-active,
.nav a:hover {
  color: #fff;
  text-decoration: underline;
}

.partners * {
  vertical-align: bottom;
  margin-right: 0.2em;
}
.partners small {
  font-size: 0.6em;
  margin-left: 3em;
}
.partners img {
  height: 3.2em;
}

@media screen and (max-width: 800px) {
  .nav {
    min-height: 900px;
  }

  .partners img {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  li small {
    display: block;
    font-size: 9pt;
  }
}

@media screen and (min-width: 800px) {
  .reflected-image {
    display: none;
  }
  .fadeout {
    display: none;
  }
}
</style>
